module.exports = __webpack_public_path__ + "img/vk.ac3fa187.svg";